import { Link } from "react-router-dom";
import cls from "./About.module.scss";
import { ORDER, titleKey } from "./data/map";
import { useTranslation } from "react-i18next";

export default function AboutHub() {
  const { t } = useTranslation();
  const totalChapters = ORDER.length;

  return (
    <div className={cls.hub}>
      <div className={cls.hubHero}>
        <div className={cls.hubCopy}>
          <p className={cls.hubEyebrow}>{t("about.title")}</p>
          <h2 className={cls.hubTitle}>{t("about.header")}</h2>
          <p className={cls.hubSubtitle} data-glow="1">
            {t("about.hubHeader")}
          </p>
        </div>
        <div className={cls.hubPanel}>
          <div className={cls.hubStat}>
            <span className={cls.hubStatValue}>{totalChapters}</span>
            <span className={cls.hubStatLabel}>{t("about.chapters")}</span>
          </div>
          <div className={cls.hubCallout}>
            <span>{t("about.respectDesc")}</span>
          </div>
        </div>
      </div>

      <ul className={cls.hubList}>
        {ORDER.map((id, index) => (
          <li key={id}>
            <Link className={cls.hubLink} to={`/about-us/${id}`}>
              <span className={cls.hubLinkIndex}>
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className={cls.hubLinkTitle}>
                {t(titleKey(id), { defaultValue: id })}
              </span>
              <span className={cls.hubLinkArrow} aria-hidden="true">
                →
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
